import jsStyleToString from "../utils/jsStyleToString.mjs"

export const styles_icon = jsStyleToString({
  maxWidth: '35px',
  height: 'auto'
})